import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'summaryCallouts',
    label: 'Summary Callouts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
